import React, {Component} from "react";
import { Link } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { getModuleUrl } from "../../moduleConfig";
import BrandMark from "../../components/layout/BrandMark";
import ManualSidebarLink from "../../components/layout/ManualSidebarLink";
import { clearAppStoragePreservingTheme } from "../../theme/branding";

class Sidebar extends Component{

  state = {
    countData : 0,
    modal : false,
    isModal : false,
    table : []
  }

  componentDidMount(){
    this.getData()
  }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

  async getData(){
    var data = await axios.get('datamigrates');
    if(data.status == 200)
    {
      this.setState({
        countData : data.data.length,
      })
    }
  }

  refresh = () => {
    this.setState({
      modal : true,
      isModal : false
    })
    axios.get('datamigrates/pull').then((response) => {
      console.log(response)
        this.setState({
          modal : true,
          isModal : true
        })
    }).catch((error) => {
      console.log(error)
    })
    this.refreshsend()
  }

  refreshsend = () => {
    this.setState({
      modal : true,
      isModal : false
    })
    axios.get('datamigrates/push').then((response) => {
      
        this.setState({
          modal : true,
          isModal : true
        })
    }).catch((error) => {
      console.log(error)
      // this.refresh()
    })
  }

  modal = () =>{
    this.setState({
      modal : false,
      isModal : false
    })
  }

  logout = (e) => {
    axios.post('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
    clearAppStoragePreservingTheme();
    window.location.replace(getModuleUrl("biblio"))
}

change = (val) => {
  this.setState({
    table : []
  })
  var table = [];
  table.push(val)
  this.setState({
    table : table
  })
  this.getData()
}
                                                                                                                                                                                                                                                                                   
    render(){

        return(     

          <div className="col-auto col-md-3 col-xl-2 bg-white p-0 border border-top-0">
                <div className="sticky-top d-flex flex-column text-white min-vh-100 pt-0 " data-simplebar>
                    <a href={getModuleUrl("biblio")} className="text-white text-decoration-none shadow text-lef font-weight-bold"  style={{ backgroundColor : "rgb(0, 108, 189)", fontWeight : 700}}>
                        <BrandMark />
                    </a>
                    
                    <ul className="nav nav-pills flex-column mb-sm-auto ms-2 mt-2"   role="tablist" id="tab-menu">
                    {
                      this.handleCheck("Afficher bibliothèque") == true && (
                        <li className="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard" data-trigger="hover">
                          <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "schoolfees").map((val) => { return "active" })} onClick={() => this.change("schoolfees")}   aria-current="page" to={"/"}>
                            <FeatherIcon icon="folder"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Dashboard</span>
                          </Link>
                        </li>
                      )
                    }

                    {
                      this.handleCheck("Afficher livre") == true && (
                        <li className="nav-item">
                          <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "books").map((val) => { return "active" })} onClick={() => this.change("books")}  aria-current="page" to={"/books"}>
                            <FeatherIcon icon="layout"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Livres</span>
                          </Link>
                        </li>
                      )
                    }

                    {
                      this.handleCheck("Afficher emprunt") == true && (
                        <li className="nav-item">
                          <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "borrows").map((val) => { return "active" })} onClick={() => this.change("borrows")}  aria-current="page" to={"/borrows"}>
                            <FeatherIcon icon="framer"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Emprunts</span>
                          </Link>
                        </li>
                      )
                    }

                    {
                      this.handleCheck("Afficher auteur") == true && (
                        <li className="nav-item">
                          <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "authors").map((val) => { return "active" })} onClick={() => this.change("authors")}  aria-current="page" to={"/authors"}>
                            <FeatherIcon icon="users"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Auteurs</span>
                          </Link>
                        </li>
                      )
                    }
                    
                    {
                      this.handleCheck("Afficher emplacement") == true && (
                        <li className="nav-item">
                          <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "spots").map((val) => { return "active" })} onClick={() => this.change("spots")}  title={"Evaluation"} aria-current="page" to={"/spots"}>
                            <FeatherIcon icon="box"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Emplacement</span>
                          </Link>
                        </li>
                      )
                    }

                    {
                      this.handleCheck("Afficher rapport") == true && (
                        <li className="nav-item">
                          <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "repports").map((val) => { return "active" })} onClick={() => this.change("repports")}  aria-current="page" to={"/repports"}>
                            <FeatherIcon icon="server"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Rapports</span>
                          </Link>
                        </li>
                      )
                    }
                    {
                      this.handleCheck("Afficher archive") == true && (
                        <li className="nav-item d-none">
                          <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "archives").map((val) => { return "active" })} onClick={() => this.change("archives")}  aria-current="page" to={"/archives"}>
                            <FeatherIcon icon="share-2"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Archive</span>
                          </Link>
                        </li>
                      )
                    }
                    {/* {
                      this.handleCheck("Afficher tableau de bord") == true && (
                        <li className="nav-item">
                          <Link className={"nav-link p-2 "}  onClick={() => this.refresh()}>
                            <FeatherIcon icon="database" size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Refresh ({this.state.countData > 0 ? this.state.countData : "0"})</span>
                          </Link>
                        </li>
                      )} */}

                      <ManualSidebarLink onSelect={() => this.change("manual")} />

                        <li className="nav-item compta-sidebar__logout">
                          <Link className="nav-link p-2" onClick={() => this.logout()} aria-current="page" to={"/#"}>
                            <FeatherIcon icon="lock" size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Déconnexion</span>
                          </Link>
                        </li>


                    </ul>
                </div>

                <Modal
                  show={this.state.modal} 
                  onHide={this.state.modal}
                  backdrop={"static"}>
                  <Modal.Header>
                      <Modal.Title className="h6 font-monospace">Actualisation des données</Modal.Title>
                  </Modal.Header>
                    <Modal.Body>
                        <div className="text-center font-monospace">{ this.state.isModal ? "" : <div><FeatherIcon className="user-search-spin" icon="loader" /></div>}</div>
                      </Modal.Body>
                    <Modal.Footer>
                      {
                        this.state.isModal && (
                          <button onClick={() => this.modal() } className="btn btn-outline-secondary btn-sm"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                        )
                      }
                    </Modal.Footer>
                </Modal>
            </div>
            
        )
    }
}
export default Sidebar;
